import { ReactNode } from "react"
import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    --gap: var(--spacing-xs, 8px);
    > *:not(:last-child) {
      margin-inline-end: var(--gap);
    }
  `,
}

export type DialogActionsProps = {
  children: ReactNode
  className?: string
}
export function DialogActions(props: DialogActionsProps) {
  const { children, className } = props
  return (
    <div data-dialog-actions className={cx(styles.root, className)}>
      {children}
    </div>
  )
}
